var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgByteanderror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.79999,
    cy: 4.3999,
    r: 0.75,
    stroke: "#5DA3E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16604 1.8999L5.30001 0.399902L4.43399 1.8999H6.16604ZM3.22412 1.32287C3.62528 1.21811 4.03863 1.2245 4.4396 1.35275L4.59191 0.87651C4.0975 0.718383 3.58741 0.711226 3.09778 0.8391L3.22412 1.32287ZM1.82574 2.22041C2.13138 1.87874 2.47493 1.62428 2.83313 1.462L2.62679 1.00656C2.19912 1.20032 1.80035 1.49885 1.45308 1.88705L1.82574 2.22041ZM1.22302 3.11292C1.3248 2.91209 1.43709 2.72636 1.55797 2.55635L1.15047 2.26662C1.0147 2.45758 0.889635 2.66468 0.777022 2.8869C0.71461 3.01007 0.763857 3.1605 0.887018 3.22291C1.01018 3.28532 1.16061 3.23608 1.22302 3.11292Z",
    fill: "#5DA3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.320007 3.96997L1.58573 5.23569",
    stroke: "#5DA3E9",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.323212 5.2373L1.58893 3.97158",
    stroke: "#5DA3E9",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByteanderror);
export default __webpack_public_path__ + "static/media/Byte and error.8bd71bccd82c1c271b79c09cc77a6b08.svg";
export { ForwardRef as ReactComponent };